var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z",
    fill: "#25262F",
    stroke: props.fill,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2577 11.8381L10.4027 15.6925C10.2602 15.8356 10.154 16.0106 10.094 16.2031C9.85274 16.9718 9.19337 19.0775 8.78774 20.3737C8.72087 20.5875 8.77587 20.8212 8.93149 20.9825C9.08649 21.1437 9.31774 21.2075 9.53462 21.1487C10.8602 20.7875 13.0302 20.1962 13.8427 19.975C14.0527 19.9175 14.244 19.8062 14.3977 19.6525L18.2352 15.8156L14.2577 11.8381ZM15.5834 10.5118L19.5609 14.4893L20.694 13.3562C21.0459 13.0043 21.2434 12.5275 21.2434 12.0306C21.2434 11.5331 21.0459 11.0562 20.694 10.7043C20.2677 10.2781 19.7952 9.8056 19.3684 9.37872C19.0171 9.02685 18.5396 8.82935 18.0427 8.82935C17.5452 8.82935 17.0684 9.02685 16.7171 9.37872L15.5834 10.5118Z",
    fill: props.fill
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.17a77c6e45ced15aac72fd1be545f5a4.svg";
export { ForwardRef as ReactComponent };